import { NgModule } from '@angular/core';
import { OpenprojectCommonModule } from '../common/openproject-common.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { CEPMIComponent } from './CEPMI.component';

export const CE_PMI_ROUTES: Ng2StateDeclaration[] = [
  {
    name: 'ce_pmi',
    url: '/ce_pmi',
    parent: 'root',
    data: {
      menuItem: 'menu-item-ce_pmi'
    },
    component: CEPMIComponent
  }
];

@NgModule({
  imports: [
    OpenprojectCommonModule,
    HttpClientModule,
    FormsModule,
    UIRouterModule.forChild({
      states: CE_PMI_ROUTES
    })
  ],
  declarations: [
    CEPMIComponent
  ]
})
export class CEPMIModule { }
